import { faCheck, faCircle, faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import React, { Suspense, useState } from 'react';
import styles from './EntityCreateStepsDot.module.sass';

const Tooltip = React.lazy(() => import('Components/Atoms/Tooltip/Tooltip'));

const EntityCreateStepsDot = ({
    state, onClick,
    title
}: Props) => {
    const [tooltipRef, setTooltipRef] = useState<any>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleTooltipHover = (value: boolean) => () => setShowTooltip(value);

    return <div
        className={styles['entitycreatestepsdot__state--'+(state)]}
        ref={setTooltipRef}
        onMouseEnter={handleTooltipHover(true)}
        onMouseLeave={handleTooltipHover(false)}
        onClick={onClick}
    >
        <FontAwesomeIcon
            icon={
                state === 'loading'
                ? faSpinnerThird
                : state === 'completed'
                ? faCheck
                : faCircle
            }
        />
        <Suspense>
            {
                showTooltip &&
                <Tooltip ref={tooltipRef}>
                    { title }
                </Tooltip>
            }
        </Suspense>
    </div>;
}

interface Props {
    state: 'completed' | 'active' | 'inactive' | 'loading',
    title: string,
    onClick: any
}

export default EntityCreateStepsDot;